// extracted by mini-css-extract-plugin
export var divider = "_redotech-redo-web-src-divider-divider";
export var dividerText = "_redotech-redo-web-src-divider-divider-text";